import { useMutation } from 'react-query';
import {
    enterpriseLoginRoute,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { deleteCookie, setCookie } from '@utils/getCookie';

export const useEnterpriseLogin = () => {
    const { mutate: enterpriseLogin } =
        useMutation({
            mutationFn: (variables: {
                company_id: Number;
            }) =>
                axiosInstance
                    .get(`${enterpriseLoginRoute}${variables.company_id ? `?company_id=${variables.company_id}` : ''}`)
                    .then((res) =>
                        res.data
                    ),
            onSuccess: (data) => {
                if (data.status === 200) {
                    deleteCookie('SU_AUTH')
                    deleteCookie('master_key')
                    deleteCookie('csrftoken')
                    setCookie('SU_AUTH', data.token, 5);
                    setCookie('master_key', data.master_id, 5);
                    setCookie('csrftoken', data.csrf_token, 5);
                    sessionStorage.removeItem('hireflixModalSeen');
                    window.location.href = '/dashboard/';
                }
            },
            onError: (error: { message?: string }) => {
                // Handle error
            },
        });
    return {
        enterpriseLogin,
    };
};
